module.exports = __webpack_public_path__ + "img/snezana_h.de355069.png";